import * as Lucide from "lucide-react";
import { REASONS } from "@/lib/data";

const WhyChoose = () => {
  return (
    <section className="py-24 lg:py-32 bg-ink text-white grain-overlay relative overflow-hidden" data-testid="why-section">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-gold/20 rounded-full blur-[140px] pointer-events-none" />
      <div className="relative container-tm">
        <div className="max-w-3xl mb-16">
          <span className="overline text-gold">Pourquoi nous choisir</span>
          <h2 className="mt-5 font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Augmentez vos revenus
            <span className="italic text-gold"> sans perdre votre temps</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {REASONS.map((r, i) => {
            const Icon = Lucide[r.icon] || Lucide.Star;
            return (
              <div
                key={r.title}
                data-testid={`reason-${i}`}
                className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 lg:p-10 hover:bg-white/10 transition-colors duration-500"
              >
                <div className="w-14 h-14 rounded-2xl bg-gold flex items-center justify-center mb-7 group-hover:scale-110 transition-transform duration-500">
                  <Icon size={24} strokeWidth={1.6} className="text-white" />
                </div>
                <p className="text-[10px] uppercase tracking-[0.25em] font-semibold text-gold mb-3">
                  0{i + 1}
                </p>
                <h3 className="font-serif text-3xl text-white mb-4 leading-tight">{r.title}</h3>
                <p className="font-sans text-sm md:text-base text-white/70 leading-relaxed">
                  {r.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
